// extracted by mini-css-extract-plugin
export default {"center-items":"global_center-items__sivLg"};